import {
  Box,
  DropdownButton,
  DropdownButtonContext,
} from '@dixa/lib-shared-habla';

import { PresenceControls } from 'components/presence/components/presenceControls';
import { PresenceControlsProps } from 'components/presence/components/presenceControls/presenceControls';

import styles from './presencePopover.module.scss';

export const PresencePopover = ({
  user,
  presence,
}: PresenceControlsProps): JSX.Element => {
  // We need to explicitly remove the content from the DOM when the dropdown is closed
  // to avoid presence controls from keeping their state
  // and changing the state for an incorrect agent

  return (
    <DropdownButton
      data-dropdown-button={true}
      dropdown={
        <DropdownButtonContext.Consumer>
          {({ dropdownOpen }) =>
            dropdownOpen ? (
              <Box className={styles.contentContainer}>
                <PresenceControls user={user} presence={presence} />
              </Box>
            ) : null
          }
        </DropdownButtonContext.Consumer>
      }
      buttonProps={{ variant: 'tertiary' }}
      icon="circle-dashed"
    />
  );
};
